import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import MultiSelect from "react-multi-select-component";
import TextEditor from '../text_editor/TextEditor';
import "./_NoticeModal.scss";
import axios, { post } from "axios";

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const ADD_NOTICE_ASSIGNMENT_DETAILS = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;
class NoticeModal extends Component {
    constructor() {
        super()
        this.state = {
            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            exam: "",
            getExamArr: [],
            examError: "",
            examSelectedvalue: [],
            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],
            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],
            studentsOptions: [],
            selectedStudents: [],
            students_error: "",
            dataClear: 0,
            loader: 0,
            submitError: "",
            submitted: false,
            ldescription: "",
            ldescription_error: "",
            file_uploading: "",
            fileError: "",
            fromDateError: "",
            formDate: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            loadingSpinner: 0,
            currentStep: 1,
        }
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                examError: "",
                classError: "",
                sectionError: "",
                ldescription: "",
                ldescription_error: "",
                students_error: "",
                dataClear: 1,
                loader: 0,
                submitError: "",
                submitted: false,
                file_uploading: "",
                fileError: "",
                loadingSpinner: 0,
                currentStep: 1,
                fromDateError: "",
                formDate: new Date().toISOString().slice(0, 10),
                currentDate: new Date().toISOString().slice(0, 10),
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    componentDidMount() {
        let branchData = this.props.globals.globalBranches;
        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        if (branchData.length > 0) {
            // Exams selection
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getExamArr.push(newObj);
            });

            //Class selection

            let selectedExamsValues = getExamArr.map((item) => item.value);

            let uniqueClasses = [];

            if (selectedExamsValues.length > 0) {

                selectedExamsValues.map((val) => {
                    let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                    uniqueClasses.push(...individualClassValues)
                });
            }

            if (uniqueClasses.length > 0) {
                [...new Set(uniqueClasses)].map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getClassArr.push(newObj);
                });

                let selectedClasses = getClassArr.map((item) => item.value);
                //section selection
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }
            }
            //  Subjects
            let studentsArray = [];
            let branchWiseData = [];

            let StudentsData = this.props.getStudents;

            if (StudentsData.length > 0) {
                let StudentsFilterData = StudentsData.filter((a) => a.branch_id == branchData[0].id);
                StudentsFilterData.map((item) => {
                    const newObj = {
                        value: item.student_id,
                        label: `${item.roll_no} => ${item.student_name}`
                    }
                    studentsArray.push(newObj)
                    branchWiseData.push({ ...item })
                })
            }

            this.setState({
                branchSearchval: {
                    value: branchData[0].id,
                    label: branchData[0].branch_name
                },
                branch: branchData[0].branch_name,
                branchSearch: branchData[0].id,
                branch_id: branchData[0].id,
                getExamArr: getExamArr,
                examSelectedvalue: getExamArr,
                getClassArr: getClassArr,
                classSelectedvalue: getClassArr,
                getSectionArr: getSectionArr,
                sectionSelectedvalue: getSectionArr,
                studentsOptions: studentsArray,
                selectedStudents: studentsArray,
                branchWiseData: branchWiseData,
                examWiseStudentData: branchWiseData,
                classWiseStudentData: branchWiseData,
                sectionWiseStudentData: branchWiseData,
            });
        }
    }

    handleMultipleSelectInputChange = (e, name) => {
        console.log("multipleChange", e, name);
        if (name == "class") {
            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }

                let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }

                let examWiseStudentData = this.state.examWiseStudentData;

                console.log("examWiseData", examWiseStudentData);

                let studentsArray = [];
                let classWiseData = [];


                if (examWiseStudentData.length > 0) {
                    console.log("eeeeee", e);
                    e.map((class_id) => {
                        let data = examWiseStudentData.filter((student) => student.class_id == class_id.value);
                        classWiseData.push(...data)
                    });

                    classWiseData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`
                        }
                        studentsArray.push(newObj);
                    });
                }
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                    subjectError: "",
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    classWiseStudentData: classWiseData,
                    sectionWiseStudentData: classWiseData,
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                    subjectError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }

                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];
                let getSectionArr = [];

                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(individualClassValues)
                    });
                }

                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses[0])].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }
                let branchWiseData = this.state.branchWiseData;

                let studentsArray = [];
                let examWiseData = [];


                if (branchWiseData.length > 0) {
                    e.map((exam) => {
                        let data = branchWiseData.filter((student) => student.exam_id == exam.value);
                        examWiseData.push(...data)
                    });

                    examWiseData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`
                        }
                        studentsArray.push(newObj);
                    });
                }

                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    examWiseStudentData: examWiseData,
                    classWiseStudentData: examWiseData,
                    sectionWiseStudentData: examWiseData,
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",


                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    getClassArr: [],
                    classSelectedvalue: [],
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    studentsOptions: [],
                    selectedStudents: [],
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];
            console.log("sectionSelectedvalue", sectionSelectedvalue);
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }
                let classWiseStudentData = this.state.classWiseStudentData;

                console.log("examWiseData", classWiseStudentData);

                let studentsArray = [];
                let sectionWiseStudentData = [];


                if (classWiseStudentData.length > 0) {
                    console.log("eeeeee", e);
                    e.map((section) => {
                        let data = classWiseStudentData.filter((student) => student.section_id == section.value);
                        sectionWiseStudentData.push(...data)
                    });

                    sectionWiseStudentData.map((item) => {
                        const newObj = {
                            value: item.student_id,
                            label: `${item.roll_no} => ${item.student_name}`
                        }
                        studentsArray.push(newObj);
                    });
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                    studentsOptions: studentsArray,
                    selectedStudents: studentsArray,
                    sectionWiseStudentData: sectionWiseStudentData,
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",
                });
            } else {
                this.setState({
                    sectionSelectedvalue: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                    studentsOptions: [],
                    selectedStudents: [],
                    studentDairyNoticeCreationDetails: [],
                    noDateError: "",

                });
            }
        }
        if (name == "student") {

            let studenttopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const stuval = e[i];
                    const newObj = {
                        label: stuval.label,
                        value: stuval.value,
                    }
                    studenttopicvalue.push(newObj);

                }
                this.setState({
                    selectedStudents: studenttopicvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    ldescription: "",
                    ldescription_error: "",
                    students_error: "",
                });
            }
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }

    selecthandleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "file_uploading") {
            const formData = new FormData();
            formData.append('file', e.target.files[0]);

            axios.post('https://rizee.in/pdfFiles.php?dairyAssignmentFiles=true', formData)
                .then((response) => {
                    console.log("response", response);
                    this.setState({ file_uploading: response.data.filename });
                })
                .catch((error) => {
                    this.setState({ error: 'An error occurred while uploading the file.' });
                });

            this.setState({
                fileError: ""
            })
        }
        if (name == "ldescription") {
            this.setState({
                ldescription_error: ""
            })
        }
        this.setState({ [name]: value });
    }

    selecthandleBranch = (name, value) => {

        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);

                let getExamArr = [];
                let getClassArr = [];
                let getSectionArr = [];

                if (branchSearchData != null) {
                    // Exams selection
                    let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id).map((item1) => item1.exam_id))].sort();

                    uniqueExams.map((val) => {
                        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualExamData.id,
                            label: individualExamData.exam
                        }
                        getExamArr.push(newObj);
                    });

                    //Class selection

                    let selectedExamsValues = getExamArr.map((item) => item.value);

                    let uniqueClasses = [];

                    if (selectedExamsValues.length > 0) {

                        selectedExamsValues.map((val) => {
                            let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                            uniqueClasses.push(individualClassValues[0])
                        });
                    }

                    if (uniqueClasses.length > 0) {
                        [...new Set(uniqueClasses)].map((val) => {
                            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualClassData.id,
                                label: individualClassData.class
                            }
                            getClassArr.push(newObj);
                        });

                        let selectedClasses = getClassArr.map((item) => item.value);
                        //section selection
                        let uniqueSections = [];

                        if (selectedClasses.length > 0) {
                            selectedExamsValues.map((val) => {
                                selectedClasses.map((val1) => {
                                    let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                    if (individualsectionValues.length > 0) {
                                        uniqueSections.push(...individualsectionValues)
                                    }
                                })
                            });
                        }

                        if (uniqueSections.length > 0) {
                            [...new Set(uniqueSections)].map((val) => {
                                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                                const newObj = {
                                    value: individualSectionData.id,
                                    label: individualSectionData.section_name
                                }
                                getSectionArr.push(newObj);
                            });
                        }
                    }

                    let studentsArray = [];
                    let branchWiseData = [];

                    let StudentsData = this.props.getStudents;

                    if (StudentsData.length > 0) {
                        let StudentsFilterData = StudentsData.filter((a) => a.branch_id == value);
                        StudentsFilterData.map((item) => {
                            const newObj = {
                                value: item.student_id,
                                label: `${item.roll_no} => ${item.student_name}`
                            }
                            studentsArray.push(newObj);
                            branchWiseData.push({ ...item })
                        })
                    }
                    this.setState({
                        branchSearchval: {
                            value: branchSearchData.id,
                            label: branchSearchData.branch_name
                        },
                        branch: branchSearchData.branch_name,
                        examError: "",
                        classError: "",
                        sectionError: "",
                        ldescription: "",
                        ldescription_error: "",
                        students_error: "",
                        selectedStudents: [],
                        title: "",
                        subTitle: "",
                        getExamArr: getExamArr,
                        examSelectedvalue: getExamArr,
                        getClassArr: getClassArr,
                        classSelectedvalue: getClassArr,
                        getSectionArr: getSectionArr,
                        sectionSelectedvalue: getSectionArr,
                        studentsOptions: studentsArray,
                        selectedStudents: studentsArray,
                        branchWiseData: branchWiseData,
                        examWiseStudentData: branchWiseData,
                        classWiseStudentData: branchWiseData,
                        sectionWiseStudentData: branchWiseData,
                    });
                }

            }
        }
        this.setState({ [name]: value });
    }

    handleFormSubmit = e => {
        if (!this.state.examSelectedvalue.length) {
            this.setState({ examError: " Please select exam " });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: " Please select class " });
            return ""
        }

        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Please select section " });
            return ""
        }
        if (!this.state.selectedStudents.length) {
            this.setState({ students_error: " Please select students " });
            return ""
        }

        if (this.state.ldescription == "") {
            this.setState({ ldescription_error: " Plase Enter  Description " })
            return ""
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            description: this.state.ldescription,
            dairy_assignment_type_id: parseInt(2),
            from_date: moment(this.state.formDate, 'YYYY-MM-DD').unix().toString(),
            file_path: this.state.file_uploading == "" || this.state.file_uploading == undefined ? "" : `https://rizee.in/educational_mngt/dairy_assignment_files/${this.state.file_uploading}`,
            branch_id: parseInt(this.state.branchSearch),
            class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
            exam_id: this.state.examSelectedvalue.map((item) => item.value).toString(),
            section_ids: this.state.sectionSelectedvalue.map((item) => item.value).toString(),
            inserted_by: parseInt(Cookies.get("id")),
            student_ids: this.state.selectedStudents.map((item) => item.value).toString(),
        }
        this.setState({ loadingSpinner: 1 })
        console.log("paramssssss", params);

        this.addDairyAssignmentDetails(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
            setTimeout(() => {
                this.props.onHide();
                window.location.reload(false);
            }, 1500);
        })
    };

    addDairyAssignmentDetails = async params => {
        await this.props.addDairyAssignmentDetails({
            variables: {
                params
            },
            update: (store, { data }) => {
                console.log("dataaaaaaaaaaaaaa", data);
                if (data.addDairyAssignmentDetails) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        })
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };

    selDate = (e) => {
        this.setState({ formDate: e.target.value })
    }

    render() {
        console.log("naresh", this.state.formDate);

        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        let studentselectall = true;
        let studentlabelledBy = "Select";
        let studentdisablesearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }

        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "Exam"
        }

        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }

        if (this.state.studentsOptions.length > 0) {
            studentselectall = true;
            studentdisablesearch = false;
        }
        else {
            studentdisablesearch = true;
            studentselectall = false;
            studentlabelledBy = "student"
        }
        return (
            <Container>
                <Row className=''>
                    <Col sm={12}>
                        <Modal
                            {...this.props}
                            size="lg"
                            aria-labelledby="example-modal-sizes-title-lg"
                        > 
                                <Modal.Header closeButton>
                                    <Modal.Title className="modal-title">Notice</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Row >
                                            <Col sm={12}>
                                                <div className='d-flex justify-content-end my-2 mr-1'>
                                                    <div>
                                                        <input type='date' className='form-control' name="formDate" max={this.state.currentDate} value={this.state.formDate} onChange={this.selDate} style={{ borderRadius: "15px" }} />
                                                        <span className="text-danger">{this.state.fromDateError}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Form.Row>

                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                                <h6>Branch<span className="text-danger f-16"></span></h6>
                                                <SelectDropDown
                                                    stateData={this.state.branchSearchval}
                                                    handleChange={this.selecthandleBranch}
                                                    name="branchSearch"
                                                    options={this.dropDownGetValues("branchSearch")}
                                                    placeholderName={'Branch'}
                                                    dropdownIndicator={{ DropdownIndicator }}
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectExam">
                                                <h6>Exam<span className="text-danger f-16">{this.state.examError}</span></h6>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Exams are selected.",
                                                        "selectSomeItems": examlabelledBy
                                                    }}
                                                    disableSearch={examdisableSearch}
                                                    hasSelectAll={examselectall}
                                                    options={this.state.getExamArr}
                                                    value={this.state.examSelectedvalue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                    labelledBy={"exam"}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectClass">
                                                <h6>Class<span className="text-danger f-16">{this.state.classError}</span></h6>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Classes are selected.",
                                                        "selectSomeItems": classlabelledBy
                                                    }}
                                                    disableSearch={classdisableSearch}
                                                    hasSelectAll={classselectall}
                                                    options={this.state.getClassArr}
                                                    value={this.state.classSelectedvalue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                    labelledBy={"class"}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectSection">
                                                <h6>Section<span className="text-danger f-16">{this.state.sectionError}</span></h6>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Sections are selected.",
                                                        "selectSomeItems": sectionlabelledBy
                                                    }}
                                                    disableSearch={sectiondisableSearch}
                                                    hasSelectAll={sectionselectall}
                                                    options={this.state.getSectionArr}
                                                    value={this.state.sectionSelectedvalue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                                    labelledBy={"section"}
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectStudent">
                                                <h6>Students<span className="text-danger f-16">{this.state.students_error}</span></h6>
                                                <MultiSelect
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Students are selected.",
                                                        "selectSomeItems": studentlabelledBy
                                                    }}
                                                    disableSearch={studentdisablesearch}
                                                    hasSelectAll={studentselectall}
                                                    options={this.state.studentsOptions}
                                                    value={this.state.selectedStudents}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "student")}
                                                    labelledBy={"student"}
                                                />

                                            </Form.Group>
                                            <Form.Group as={Col} lg={6} md={12} sm={12} controlId="selectFile">
                                                <h6>Upload Pdf<span className="f-16  text-danger">{this.state.fileError}</span></h6>
                                                <div className="form-control">
                                                    <Form.Control type="file" name="file_uploading" id="file" accept=".pdf" onChange={(e) => this.selecthandleInputChange(e)} />
                                                </div>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form>
                                    <section>

                                        <Row className='mt-4'>
                                            <Col as={Col} lg={9} md={12} sm={12}>
                                                <h6>Description<span className="f-16 text-danger">{this.state.ldescription_error}</span></h6>
                                                <textarea className='description_area' name="ldescription" onChange={this.selecthandleInputChange}></textarea>
                                            </Col>
                                            <Col as={Col} lg={3} md={12} sm={12} className="text-center">
                                                <button className='Notice_Button text-uppercase' onClick={this.handleFormSubmit}>
                                                    {
                                                        this.state.loadingSpinner == 1 ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : ""
                                                    }Submit</button>
                                                <div className='d-block'>
                                                    {this.state.currentStep == 5 ? (
                                                        <Form.Text className="form-text  mb-2  p" style={{ textAlign: "center" }}>
                                                            <span style={{ color: "green" }}>successfully Submitted</span>
                                                        </Form.Text>
                                                    ) : (
                                                        <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                                                            {this.state.submitError}
                                                        </Form.Text>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </section>
                                </Modal.Body> 
                        </Modal>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default withRouter(compose(
    graphql(ADD_NOTICE_ASSIGNMENT_DETAILS, {
        name: "addDairyAssignmentDetails"
    }))(NoticeModal));

